import React from 'react';
import { Button, Card, CardContent } from "@mui/material";
import { Cloud, Database, Download, LogOut, Trash2, Upload } from "lucide-react";
import auth from '../utils/auth';
import { isSupabaseConfigured } from '../utils/supabaseClient';

const AccountPage = ({ downloadExcel, uploadExcel, handleClearAll, onLogout }) => {
    const user = auth.getCurrentUser();

    return (
        <div className="max-w-4xl mx-auto space-y-6">
            <div>
                <p className="text-xs uppercase tracking-[0.22em] text-teal-300/80">Профиль</p>
                <h2 className="panel-title mt-2 text-3xl font-bold">Аккаунт и данные</h2>
            </div>

            <Card elevation={0}>
                <CardContent>
                    <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
                        <div>
                            <h3 className="text-2xl font-semibold text-white">{user?.name}</h3>
                            <p className="muted-label mt-1">{user?.email}</p>
                        </div>
                        <Button
                            variant="contained"
                            color="error"
                            startIcon={<LogOut size={18} />}
                            onClick={onLogout}
                            sx={{ minHeight: 44 }}
                        >
                            Выйти
                        </Button>
                    </div>
                </CardContent>
            </Card>

            <Card elevation={0}>
                <CardContent>
                    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                        <div className="flex items-start gap-3">
                            <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-teal-300/12 text-teal-300">
                                {isSupabaseConfigured ? <Cloud size={22} /> : <Database size={22} />}
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold text-white">
                                    {isSupabaseConfigured ? 'Supabase подключен' : 'Локальное хранилище'}
                                </h3>
                                <p className="muted-label text-sm">
                                    {isSupabaseConfigured
                                        ? 'Расходы синхронизируются с облачной БД.'
                                        : 'Добавь REACT_APP_SUPABASE_URL и publishable key, чтобы включить облачную БД.'}
                                </p>
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Card elevation={0}>
                    <CardContent className="space-y-4">
                        <h3 className="text-lg font-semibold text-white">Резервная копия</h3>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            <Button variant="contained" startIcon={<Download />} onClick={downloadExcel}>
                                Скачать Excel
                            </Button>
                            <input
                                type="file"
                                accept=".xlsx"
                                onChange={uploadExcel}
                                style={{ display: 'none' }}
                                id="upload-excel"
                            />
                            <label htmlFor="upload-excel">
                                <Button fullWidth variant="outlined" component="span" startIcon={<Upload />}>
                                    Загрузить
                                </Button>
                            </label>
                        </div>
                    </CardContent>
                </Card>

                <Card elevation={0}>
                    <CardContent className="space-y-4">
                        <h3 className="text-lg font-semibold text-white">Опасная зона</h3>
                        <Button
                            fullWidth
                            variant="contained"
                            color="error"
                            startIcon={<Trash2 />}
                            onClick={handleClearAll}
                            sx={{ minHeight: 44 }}
                        >
                            Очистить все данные
                        </Button>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
};

export default AccountPage;
